module.exports = __webpack_public_path__ + "static/fonts/font-number2.07d53b5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/public/assets/font/number/font-number2.ttf
// module id = qpQp
// module chunks = 4